import './App.css';
import YugiApp from "./components/YugiApp.js"

function App() {
  return (
    <div className="App">
      <YugiApp />
    </div>
  );
}

export default App;
